<script setup lang="ts">
import { ref } from 'vue'

defineProps({
  hasCloseButton: {
    type: Boolean,
    default: true
  }
})

const dialog = ref<{ showModal: () => void; close: () => void } | null>(null)

const open = () => {
  dialog.value!.showModal()
}

const close = () => {
  dialog.value!.close()
}

defineExpose({
  open,
  close
})
</script>

<template>
  <dialog
    ref="dialog"
    class="mt-10 duration-500 w-full top-0 start-0 z-50 transition-all overflow-y-auto pointer-events-none bg-transparent backdrop:bg-gray-800/50 backdrop:backdrop-blur-md"
  >
    <div class="sm:max-w-lg sm:w-full sm:mx-auto rounded-xl overflow-hidden">
      <div class="flex flex-col bg-white shadow-sm rounded-xl pointer-events-auto">
        <button
          v-if="hasCloseButton"
          @click="close()"
          type="button"
          class="self-end flex justify-center items-center size-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
        >
          <span class="sr-only">Close</span>
          <svg
            class="flex-shrink-0 size-7"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
        <div class="px-4 py-4 overflow-y-auto">
          <slot></slot>
        </div>
      </div>
    </div>
  </dialog>
</template>
